import React from 'react'

export default function Section({ children }) {
  return <div className="mb-5">{children}</div>
}
